import { render, staticRenderFns } from "./ErrorMessageCollectionContainer.vue?vue&type=template&id=4eea42bb&scoped=true&"
import script from "./ErrorMessageCollectionContainer.vue?vue&type=script&lang=js&"
export * from "./ErrorMessageCollectionContainer.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMessageCollectionContainer.vue?vue&type=style&index=0&id=4eea42bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eea42bb",
  null
  
)

export default component.exports